import React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import Img from "gatsby-image";

const sizes = {
 small: {
    side: '80px',
    padding: '8px'
  },
  medium: {
    side: '120px',
    padding: '10px'
  },
  big: {
    side: '180px',
    padding: '12px'
  }
};

const PartnerImage = styled(Img)`
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  display: flex;
  background-color: #F2F2F3;
  width: ${props => props.size.side};
  height: ${props => props.size.side};
  padding: ${props => props.size.padding};
`;

const PartnerBox = ({ partner, size }) => (
  <Container size={sizes[size]}>
    <PartnerImage
      fluid={partner.logo.childImageSharp.fluid}
      alt={partner.name}
      title={partner.name}
    />
  </Container>
);

PartnerBox.defaultProps = {
  size: 'small'
};

PartnerBox.propTypes = {
  partner: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'big'])
};

export default PartnerBox;